import { getStyleRules } from '@/vendors/tiptap/helpers'
import { get as _get } from 'lodash'

export default (elment, rule, defaultValue = undefined) => {
  return _get(getStyleRules(elment), rule, defaultValue)
}